<template>
  <div class="newsletter-qta" :class="{ 'is-visible': display }">
    <a class="newsletter-qta-inner" href="/newsletter-subscribe">
      Thanks for visiting our website! Do you like what you see? We also have a
      newsletter that you can subscribe to
      <svg width="29px" height="13px" viewBox="0 0 29 13">
        <path
          fill="#F0F0F0"
          d="M22.1303097,0.0995426189 L21.9300491,0.299775601 C21.7973533,0.432471436 21.7973533,0.647666579 21.9300491,0.780390071 L26.9850469,5.83538786 L0.33984294,5.83538786 C0.152166004,5.83538786 0,5.98755386 0,6.1752308 L0,6.45843325 C0,6.64611019 0.152166004,6.79827619 0.33984294,6.79827619 L26.9850469,6.79827619 L21.9300491,11.853274 C21.7973533,11.9859698 21.7973533,12.201165 21.9300491,12.3338884 L22.1303097,12.5341214 C22.2630332,12.6668173 22.4782007,12.6668173 22.6108966,12.5341214 L28.587934,6.55713926 C28.7206299,6.42441577 28.7206299,6.20924828 28.587934,6.07649713 L22.6108966,0.0995426189 C22.4782007,-0.033180873 22.2630332,-0.033180873 22.1303097,0.0995426189 Z"
        ></path>
      </svg>
    </a>
    <a class="newsletter-qta-close" href="#" @click.prevent="dismiss">
      <i class="fal fa-times-circle"></i>
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    navigationTime() {
      return this.$store.getters.navigationTime
    },
    isDismissed() {
      return this.$store.getters.isNewsletterDismissed
    },
    display() {
      return !this.isDismissed && this.navigationTime > 120
    }
  },
  mounted() {
    this.incrementTime()
  },
  methods: {
    incrementTime() {
      setInterval(() => {
        this.$store.dispatch('incrementTime')
      }, 1000)
    },
    dismiss() {
      this.$store.dispatch('dismissNewsletter')
    }
  }
}
</script>

<style lang="scss">
.newsletter-qta {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  min-height: 40px;
  padding: 10px 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff3777;
  color: #f0f0f0;
  font-size: 14.5px;
  text-align: center;
  text-transform: uppercase;
}

.newsletter-qta-close {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
